import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, share } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private httpClient = inject(HttpClient);

  public config$: any | undefined;

  constructor() {
    this.config$ = this.httpClient.get<any>(environment['serviceBaseUrl'] + '/api/v1/Roles/Admin').pipe(share());
  }
}
